// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import d2fmt from '@/ddv2.library/utils/formatter'
import dayjs from 'dayjs'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
import google from '@/ddv2.library/utils/google'
// import tax from '@/ddv2.library/tax'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdCustomButton = () => import('@/components/DdCustomButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdPackageTeikeiCourseSearchTextBox = () => import('@/components/DdPackageTeikeiCourseSearchTextBox')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')

export default {
  name: 'DdHaishaJuchuDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCalcDistance,
    DdCalcTankaButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdCustomButton,
    DdDateBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdPackageTeikeiCourseSearchTextBox,
    DdSectionTitle,
    DdSubHeader,
    DdTextArea,
    DdTextBox,
    DdTextBoxSwitching,
    DdTimeBoxSwitching
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 受注情報構造体
     */
    dataSource: Object,
    /**
    * 読取モード
    */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
    * 時刻必須モード
    */
    isRequiredHms: {
      type: Boolean,
      default: false
    },
    /**
    * 配車年月日
    */
    unkoYmd: {
      type: String,
      default: filter.dateFormatter(new Date())
    }
  },

  data: () => ({
    invalidMessage: '',
    baseYmd: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    // 戻り値用定義
    vwCD2plmd00201: {},
    tempVwCD2plmd00201: {},
    // 作業変数定義
    colorDialog: false,
    chipColorTmp: '',
    expandKeiyuchi: false,
    // 表示制御
    baseSectionCol: 9,
    selectNinushiCd: '',
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    hinmeiSwitch: false,
    newEditMode: false,
    continuousSaveMode: false,
    saveCount: 0,
    modeKengen: 0
  }),

  created () {
    this.initialize()
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
    /*
    'rec.juchuYmd': function (n) {
      if (this.rec.sagyoYoteiYmd === '') {
        this.rec.sagyoYoteiYmd = n
      }
      if (this.rec.hatsuchiYmd === '') {
        this.rec.hatsuchiYmd = n
      }
      if (this.rec.chakuchiYmd === '') {
        this.rec.chakuchiYmd = n
      }
    },
    'rec.juchuEigyosho': function (n) {
      if (this.rec.sagyoEigyosho === '') {
        this.rec.sagyoEigyosho = this.rec.juchuEigyosho
      }
    }
    */
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyosho: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoListExcludes99 () {
      const self = this
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd && elem.eigyoshoKbn !== '03' & elem.eigyoshoCd !== '99'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const self = this
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const self = this
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.tokuisakiFlg === true
      })
    },
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHinmeiList () {
      const self = this
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
      /*
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.sagyoinTeateKingaku1) { elem.sagyoinTeateKingaku1 = filter.numericFormatter(elem.sagyoinTeateKingaku1) }
        if (elem.sharyoKeihiHiwayEtc) { elem.sharyoKeihiHiwayEtc = filter.numericFormatter(elem.sharyoKeihiHiwayEtc) }
        if (elem.sharyoKeihiHiwayGenkin) { elem.sharyoKeihiHiwayGenkin = filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) }
        if (elem.sharyoKeihiFerry) { elem.sharyoKeihiFerry = filter.numericFormatter(elem.sharyoKeihiFerry) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
      */
    },
    // 往復種別
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 貨物区分フィルター
    filteredKamotsuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT025')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },

    // ----------------------------------------------------------------------------------------------------
    // 金額計算
    // ----------------------------------------------------------------------------------------------------
    calcSeikyuKingakuAmount () {
      let amount = 0

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
      }

      return amount
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.vwCD2plmd00201.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.vwCD2plmd00201.unchinKeisanKbn === '01') {
        let juchuSuryo = this.vwCD2plmd00201.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.vwCD2plmd00201.unchinKeisanKbn === '02') {
        let juchuJuryo = this.vwCD2plmd00201.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.vwCD2plmd00201.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }
      amount = this.calcFraction(amount)
      // 登録用項目への値設定
      // if (this.vwCD2plmd00201) this.vwCd2plmd00201.kihonUnchin = amount

      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.vwCD2plmd00201) || this.vwCD2plmd00201.length === 0) { return 0 }

      let userKingakuKazei4 = this.vwCD2plmd00201.userKingakuKazei4
      let userKingakuKazei3 = this.vwCD2plmd00201.userKingakuKazei3
      let userKingakuKazei1 = this.vwCD2plmd00201.userKingakuKazei1
      let nenryoSurcharge = this.vwCD2plmd00201.nenryoSurcharge
      let tsumikomiKingaku = this.vwCD2plmd00201.tsumikomiKingaku
      let torioroshiKingaku = this.vwCD2plmd00201.torioroshiKingaku
      let taikiJikanKingaku = this.vwCD2plmd00201.taikiJikanKingaku
      let futaiGyomuKingaku = this.vwCD2plmd00201.futaiGyomuKingaku

      if (userKingakuKazei4 === undefined || userKingakuKazei4 === '' || userKingakuKazei4 === null) { userKingakuKazei4 = '0' }
      if (userKingakuKazei3 === undefined || userKingakuKazei3 === '' || userKingakuKazei3 === null) { userKingakuKazei3 = '0' }
      if (userKingakuKazei1 === undefined || userKingakuKazei1 === '' || userKingakuKazei1 === null) { userKingakuKazei1 = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(userKingakuKazei4, 10) +
                parseInt(userKingakuKazei3, 10) +
                parseInt(userKingakuKazei1, 10) +
                parseInt(nenryoSurcharge, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(torioroshiKingaku, 10) +
                parseInt(taikiJikanKingaku, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.vwCD2plmd00201) || this.vwCD2plmd00201.length === 0) { return 0 }

      let hiwayPrice = this.vwCD2plmd00201.hiwayPrice
      let userKingakuHikazei1 = this.vwCD2plmd00201.userKingakuHikazei1
      let userKingakuHikazei2 = this.vwCD2plmd00201.userKingakuHikazei2

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (userKingakuHikazei1 === undefined || userKingakuHikazei1 === '' || userKingakuHikazei1 === null) { userKingakuHikazei1 = '0' }
      if (userKingakuHikazei2 === undefined || userKingakuHikazei2 === '' || userKingakuHikazei2 === null) { userKingakuHikazei2 = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(userKingakuHikazei1, 10) + parseInt(userKingakuHikazei2, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.vwCD2plmd00201) || this.vwCD2plmd00201.length === 0) { return 0 }

      let jikanWarimashiKingaku = this.vwCD2plmd00201.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.vwCD2plmd00201.kyoriWarimashiKingaku
      let userKingakuKazei2 = this.vwCD2plmd00201.userKingakuKazei2

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (userKingakuKazei2 === undefined || userKingakuKazei2 === '' || userKingakuKazei2 === null) { userKingakuKazei2 = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(userKingakuKazei2, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10)

      return amount
    },

    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    dispCreateButton () {
      return this.modeKengen !== 0
    },
    dispDeleteButton () {
      const self = this
      console.log('dispDeleteButton', self.modeKengen, self.vwCD2plmd00201.id)
      const dispDeleteButton = self.modeKengen === 2 && self.vwCD2plmd00201.id !== 'NEW' && self.vwCD2plmd00201.id > 0
      return dispDeleteButton
    },
    readOnlyMode () {
      return this.readOnly || this.vwCD2plmd00201.kakuteiFlg || this.vwCD2plmd00201.seikyuZumiFlg
    },
    isMapUsable () {
      if ((this.vwCD2plmd00201.hatsuchiId) ||
          (this.vwCD2plmd00201.keiyuchiId1) ||
          (this.vwCD2plmd00201.keiyuchiId2) ||
          (this.vwCD2plmd00201.keiyuchiId3) ||
          (this.vwCD2plmd00201.keiyuchiId4) ||
          (this.vwCD2plmd00201.keiyuchiId5) ||
          (this.vwCD2plmd00201.chakuchiId)) {
        return true
      }
      return false
    }
  },
  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForRegister(option)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.continuousSaveMode = false
      this.baseSectionCol = 9
      this.clearInvalidMessage(this.$refs)
      this.chipColorTmp = '#00FF00'
      this.saveCount = 0
      this.baseYmd = filter.dateFormatter(new Date())

      if ((this.dataSource) && this.dataSource !== null) {
        var initVwCD2plmd00201 = Object.assign({}, this.dataSource)

        if (initVwCD2plmd00201.id === 'NEW') {
          const today = filter.dateFormatter(new Date())
          const miwariateEigyoshoInfo = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', '99', today) : null
          this.selectNinushiCd = ''
          this.baseSectionCol = 9
          this.newEditMode = true
          this.hatsuchiSwitch = false
          this.hatsuchiHmsSwitch = false
          this.chakuchiSwitch = false
          this.chakuchiHmsSwitch = false
          this.hinmeiSwitch = false
          this.expandKeiyuchi = false
          initVwCD2plmd00201 = {
            ...initVwCD2plmd00201,
            kakuteiFlg: false,
            juchuYmd: today,
            juchuEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, today).id : null,
            sagyoYmd: this.unkoYmd,
            sagyoEigyoshoId: miwariateEigyoshoInfo ? miwariateEigyoshoInfo.id : null,
            ninushiId: null,
            teikeiCourseNo: null,
            keiyakuHojoKbn: '1',
            startLockFlg: true,
            hatsuchiId: null,
            keiyuchiId1: null,
            keiyuchiId2: null,
            keiyuchiId3: null,
            keiyuchiId4: null,
            keiyuchiId5: null,
            chakuchiId: null,
            chakuchiYmd: initVwCD2plmd00201.hatsuchiYmd,
            seikyuYoteiYmd: initVwCD2plmd00201.hatsuchiYmd,
            endLockFlg: false,
            shujitsuFlg: false
          }
        } else if (initVwCD2plmd00201.id > 0) {
          this.newEditMode = false
          this.baseSectionCol = 12
          this.baseYmd = initVwCD2plmd00201.juchuYmd
          this.chipColorTmp = initVwCD2plmd00201.color
          this.selectNinushiCd = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00201.ninushiId).torihikisakiCd
          initVwCD2plmd00201.trJuchuMeisaiInsDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00201.trJuchuMeisaiInsDate)
          var iUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00201.trJuchuMeisaiInsUserId)
          if (iUser) {
            initVwCD2plmd00201.trJuchuMeisaiInsUserCdNm = iUser.jininCd + ':' + iUser.jininNmSei
          }
          initVwCD2plmd00201.trJuchuMeisaiUpdDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00201.trJuchuMeisaiUpdDate)
          var uUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00201.trJuchuMeisaiUpdUserId)
          if (uUser) {
            initVwCD2plmd00201.trJuchuMeisaiUpdUserCdNm = uUser.jininCd + ':' + uUser.jininNmSei
          }
          initVwCD2plmd00201.kakuteiFlg = this.isRequiredHms ? initVwCD2plmd00201.kakuteiFlg : false
          // 時間項目変換
          if (initVwCD2plmd00201.yoteiSagyoJikan) {
            initVwCD2plmd00201.yoteiSagyoJikan = filter.minToTimeFormatter(initVwCD2plmd00201.yoteiSagyoJikan)
          }
          if (initVwCD2plmd00201.warimashiTaishoJikan) {
            initVwCD2plmd00201.warimashiTaishoJikan = filter.minToTimeFormatter(initVwCD2plmd00201.warimashiTaishoJikan)
          }
          if (initVwCD2plmd00201.taikiJikan) {
            initVwCD2plmd00201.taikiJikan = filter.minToTimeFormatter(initVwCD2plmd00201.taikiJikan)
          }
        }
        this.vwCD2plmd00201 = Object.assign({}, initVwCD2plmd00201)
        this.tempVwCD2plmd00201 = Object.assign({}, this.vwCD2plmd00201)
        this.dispSwitchControl()
        this.calcSeikyuGokeiAmount()
        initVwCD2plmd00201 = undefined
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 取引先マスタ項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 荷主IDが入力されたら、取引先マスタ設定情報を取得メソッドを呼ぶ
    changeNinushi: function () {
      if (!this.vwCD2plmd00201.ninushiId) {
        this.selectNinushiCd = ''
        return
      }
      this.vwCD2plmd00201.torihikisakiCd = indexeddb.getRecord(this.torihikisakiList, this.vwCD2plmd00201.ninushiId).torihikisakiCd

      if (this.vwCD2plmd00201.hatsuchiId) {
        const hatsuchiTorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.hatsuchiId).torihikisakiCd
        this.vwCD2plmd00201.hatsuchiId = hatsuchiTorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== hatsuchiTorihikisakiCd ? null : this.vwCD2plmd00201.hatsuchiId
        this.vwCD2plmd00201.hatsuchiCd = hatsuchiTorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== hatsuchiTorihikisakiCd ? '' : this.vwCD2plmd00201.hatsuchiCd
      }
      if (this.vwCD2plmd00201.keiyuchiId1) {
        const keiyuchi1TorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.keiyuchiId1).torihikisakiCd
        this.vwCD2plmd00201.keiyuchiId1 = keiyuchi1TorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== keiyuchi1TorihikisakiCd ? null : this.vwCD2plmd00201.keiyuchiId1
      }
      if (this.vwCD2plmd00201.keiyuchiId2) {
        const keiyuchi2TorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.keiyuchiId2).torihikisakiCd
        this.vwCD2plmd00201.keiyuchiId2 = keiyuchi2TorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== keiyuchi2TorihikisakiCd ? null : this.vwCD2plmd00201.keiyuchiId2
      }
      if (this.vwCD2plmd00201.keiyuchiId3) {
        const keiyuchi3TorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.keiyuchiId3).torihikisakiCd
        this.vwCD2plmd00201.keiyuchiId3 = keiyuchi3TorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== keiyuchi3TorihikisakiCd ? null : this.vwCD2plmd00201.keiyuchiId3
      }
      if (this.vwCD2plmd00201.keiyuchiId4) {
        const keiyuchi4TorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.keiyuchiId4).torihikisakiCd
        this.vwCD2plmd00201.keiyuchiId4 = keiyuchi4TorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== keiyuchi4TorihikisakiCd ? null : this.vwCD2plmd00201.keiyuchiId4
      }
      if (this.vwCD2plmd00201.keiyuchiId5) {
        const keiyuchi5TorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.keiyuchiId5).torihikisakiCd
        this.vwCD2plmd00201.keiyuchiId5 = keiyuchi5TorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== keiyuchi5TorihikisakiCd ? null : this.vwCD2plmd00201.keiyuchiId5
      }

      if (this.vwCD2plmd00201.chakuchiId) {
        const chakuchiTorihikisakiCd = indexeddb.getRecord(this.filteredHacchakuchiList, this.vwCD2plmd00201.chakuchiId).torihikisakiCd
        this.vwCD2plmd00201.chakuchiId = chakuchiTorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== chakuchiTorihikisakiCd ? null : this.vwCD2plmd00201.chakuchiId
        this.vwCD2plmd00201.chakuchiCd = chakuchiTorihikisakiCd && this.vwCD2plmd00201.torihikisakiCd !== chakuchiTorihikisakiCd ? '' : this.vwCD2plmd00201.chakuchiCd
      }
      this.getTorihikisakiInfo(this.vwCD2plmd00201.ninushiId)
    },
    getTorihikisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2plmd00201/MstTorihikisakiInfoFind?id=${this.vwCD2plmd00201.ninushiId}`)
          .then((data) => {
            const initVwCD2plmd00201 = Object.assign({}, this.vwCD2plmd00201)
            initVwCD2plmd00201.color = data.payload.color ?? '#00FF00'
            this.chipColorTmp = initVwCD2plmd00201.color
            this.selectNinushiCd = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00201.ninushiId).torihikisakiCd
            initVwCD2plmd00201.keijobiKbn = data.payload.keijobiKbn ?? '1'
            initVwCD2plmd00201.unchinHasuKeisanKbn = data.payload.unchinHasuKeisanKbn ?? '02'
            initVwCD2plmd00201.unchinKeisanKbn = !initVwCD2plmd00201.unchinKeisanKbn && data.payload.unchinKeisanKbn ? data.payload.unchinKeisanKbn : initVwCD2plmd00201.unchinKeisanKbn
            initVwCD2plmd00201.keijobiKbn === '1' ? this.$set(initVwCD2plmd00201, 'seikyuYoteiYmd', initVwCD2plmd00201.hatsuchiYmd) : this.$set(initVwCD2plmd00201, 'seikyuYoteiYmd', initVwCD2plmd00201.chakuchiYmd)
            this.vwCD2plmd00201 = Object.assign({}, initVwCD2plmd00201)
            this.calcJikanWarimashiKingaku()
            this.calcKyoriWarimashiKingaku()
          })
        resolve()
      })
    },
    hacchakuchiFilter (elem) {
      const self = this
      return (elem.tekiyoStartYmdDisp <= self.baseYmd) &&
            (elem.tekiyoEndYmdDisp >= self.baseYmd) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },
    // 反映ボタン押下時
    teikeiCourseNoSync: function () {
      if (!this.vwCD2plmd00201.teikeiCourseNo) { return }
      var teikeiInfo = this.getTeikeiInfo(this.vwCD2plmd00201.teikeiCourseNo)
      this.teikeiCourseNoDialogSync(teikeiInfo)
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      var initVwCD2plmd00201 = Object.assign({}, this.vwCD2plmd00201)
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
      this.hinmeiSwitch = false
      initVwCD2plmd00201 = {
        ...initVwCD2plmd00201,
        teikeiKihonNo: elem.teikeiKihonNo,
        sagyoEigyoshoId: elem.tantoEigyoshoId,
        ohfukuSbt: elem.ohfukuSbt,
        chumonNo: elem.chumonNo,
        ninushiId: elem.tokuisakiId,
        mstHinmeiId: elem.mstHinmeiId,
        hinmeiBiko: elem.hinmeiBiko,
        hatsuchiId: elem.hatsuchiId,
        hatsuchiBiko: elem.hatsuchiBiko,
        hatsuchiHms: elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : null,
        hatsuchiHmsBiko: elem.hatsuchiHmsBiko,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiId1Biko: elem.keiyuchiId1Biko,
        keiyuchiId2: elem.keiyuchiId2,
        keiyuchiId2Biko: elem.keiyuchiId2Biko,
        keiyuchiId3: elem.keiyuchiId3,
        keiyuchiId3Biko: elem.keiyuchiId3Biko,
        keiyuchiId4: elem.keiyuchiId4,
        keiyuchiId4Biko: elem.keiyuchiId4Biko,
        keiyuchiId5: elem.keiyuchiId5,
        keiyuchiId5Biko: elem.keiyuchiId5Biko,
        chakuchiId: elem.chakuchiId,
        chakuchiBiko: elem.chakuchiBiko,
        chakuchiHms: elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : null,
        chakuchiHmsBiko: elem.chakuchiHmsBiko,
        unchinKeisanKbn: elem.unchinKeisanKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        yoteiSokoKyori: d2fmt.removeComma(elem.yoteiSokoKyori),
        yoteiSagyoJikan: elem.yoteiSagyoJikanDisp,
        juchuSuryo: d2fmt.removeComma(elem.juchuSuryo),
        unitKbn: elem.unitKbn,
        juchuJuryo: d2fmt.removeComma(elem.juchuJuryo),
        tanka: d2fmt.removeComma(elem.tanka),
        hiwayPrice: d2fmt.removeComma(elem.hiwayPrice),
        userKingakuKazei1: d2fmt.removeComma(elem.unchinHokaKingaku),
        userKingakuKazei4: d2fmt.removeComma(elem.hokanKingaku),
        userKingakuKazei3: d2fmt.removeComma(elem.niekiKingaku),
        userKingakuHikazei1: d2fmt.removeComma(elem.unchinHokaHikazei),
        userKingakuHikazei2: d2fmt.removeComma(elem.tatekaekinHikazei),
        warimashiTaishoJikan: elem.warimashiTaishoJikanDisp,
        warimashiJikanTanka: d2fmt.removeComma(elem.warimashiJikanTanka),
        warimashiTaishoKyori: d2fmt.removeComma(elem.warimashiTaishoKyori),
        warimashiKyoriTanka: d2fmt.removeComma(elem.warimashiKyoriTanka),
        userKingakuKazei2: d2fmt.removeComma(elem.warimashiSonotaKingaku),
        taikiJikan: elem.taikiJikanDisp,
        taikiJikanTanka: d2fmt.removeComma(elem.taikiJikanTanka),
        nenryoSurcharge: d2fmt.removeComma(elem.nenryoSurcharge),
        tsumikomiKingaku: d2fmt.removeComma(elem.tsumikomiKingaku),
        torioroshiKingaku: d2fmt.removeComma(elem.torioroshiKingaku),
        taikiJikanKingaku: d2fmt.removeComma(elem.taikiJikanKingaku),
        futaiGyomuKingaku: d2fmt.removeComma(elem.futaiGyomuKingaku),
        sagyoinTeateKingaku1: d2fmt.removeComma(elem.sagyoinTeateKingaku1),
        sharyoKeihiHiwayEtc: d2fmt.removeComma(elem.sharyoKeihiHiwayEtc),
        sharyoKeihiHiwayGenkin: d2fmt.removeComma(elem.sharyoKeihiHiwayGenkin),
        sharyoKeihiFerry: d2fmt.removeComma(elem.sharyoKeihiFerry),
        seikyuBiko: elem.seikyuBiko,
        renrakuBiko: elem.renrakuBiko
      }
      if (initVwCD2plmd00201.hatsuchiYmd && initVwCD2plmd00201.hatsuchiHms && initVwCD2plmd00201.chakuchiHms && (initVwCD2plmd00201.hatsuchiYmd >= initVwCD2plmd00201.chakuchiYmd || !initVwCD2plmd00201.chakuchiYmd) && initVwCD2plmd00201.hatsuchiHms > initVwCD2plmd00201.chakuchiHms) {
        initVwCD2plmd00201.chakuchiYmd = filter.dateFormatter(dayjs(initVwCD2plmd00201.hatsuchiYmd).add(1, 'd'))
      }
      this.vwCD2plmd00201 = Object.assign({}, initVwCD2plmd00201)
      initVwCD2plmd00201 = undefined
      this.dispSwitchControl()
      this.calcJikanWarimashiKingaku()
      this.calcKyoriWarimashiKingaku()
      this.calcSeikyuGokeiAmount()
    },
    // 請求合計金額算出
    calcSeikyuGokeiAmount: function () {
      let amount = 0

      let seikyuUnchin = this.vwCD2plmd00201.kihonUnchin ?? '0'
      let seikyuTsukoryo = this.vwCD2plmd00201.hiwayPrice ?? '0'
      let seikyuKingaku1 = this.vwCD2plmd00201.userKingakuKazei1 ?? '0'
      let seikyuKingaku2 = this.vwCD2plmd00201.userKingakuKazei2 ?? '0'
      let seikyuKingaku3 = this.vwCD2plmd00201.userKingakuKazei3 ?? '0'
      let seikyuKingaku4 = this.vwCD2plmd00201.userKingakuKazei4 ?? '0'
      let seikyuHikazeiKingaku1 = this.vwCD2plmd00201.userKingakuHikazei1 ?? '0'
      let seikyuHikazeiKingaku2 = this.vwCD2plmd00201.userKingakuHikazei2 ?? '0'

      if (this.vwCD2plmd00201.kihonUnchin === undefined || this.vwCD2plmd00201.kihonUnchin === '') { seikyuUnchin = '0' }
      if (this.vwCD2plmd00201.hiwayPrice === undefined || this.vwCD2plmd00201.hiwayPrice === '') { seikyuTsukoryo = '0' }
      if (this.vwCD2plmd00201.userKingakuKazei1 === undefined || this.vwCD2plmd00201.userKingakuKazei1 === '') { seikyuKingaku1 = '0' }
      if (this.vwCD2plmd00201.userKingakuKazei2 === undefined || this.vwCD2plmd00201.userKingakuKazei2 === '') { seikyuKingaku2 = '0' }
      if (this.vwCD2plmd00201.userKingakuKazei3 === undefined || this.vwCD2plmd00201.userKingakuKazei3 === '') { seikyuKingaku3 = '0' }
      if (this.vwCD2plmd00201.userKingakuKazei4 === undefined || this.vwCD2plmd00201.userKingakuKazei4 === '') { seikyuKingaku4 = '0' }
      if (this.vwCD2plmd00201.userKingakuHikazei1 === undefined || this.vwCD2plmd00201.userKingakuHikazei1 === '') { seikyuHikazeiKingaku1 = '0' }
      if (this.vwCD2plmd00201.userKingakuHikazei2 === undefined || this.vwCD2plmd00201.userKingakuHikazei2 === '') { seikyuHikazeiKingaku2 = '0' }

      const seikyuKazeiAmount = parseInt(seikyuUnchin, 10) + parseInt(seikyuKingaku1, 10) + parseInt(seikyuKingaku2, 10) + parseInt(seikyuKingaku3, 10) + parseInt(seikyuKingaku4, 10) + parseInt(seikyuHikazeiKingaku1, 10) + parseInt(seikyuHikazeiKingaku2, 10)

      amount = seikyuKazeiAmount + parseInt(seikyuTsukoryo, 10)

      return amount
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // キャンセルボタン押下
    // --------------------------------------------------------------------------------
    onCancelClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.vwCD2plmd00201 = Object.assign({}, this.tempVwCD2plmd00201)
        this.dispSwitchControl()
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 削除ボタン押下
    // --------------------------------------------------------------------------------
    onDeleteClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2plmd00201/JuchuDelete', self.vwCD2plmd00201).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            self.$emit('delete', self.vwCD2plmd00201)
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onContinuousSaveClick: function (e) {
      this.continuousSaveMode = true
      this.onSaveClick()
    },
    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        const x = this.vwCD2plmd00201
        x.id = -1
        x.trSagyoKeikakuKihonId = null
        x.trSagyoKeikakuMeisaiId = null
        x.trJuchuKihonId = null
        x.trJuchuMeisaiId = null
        x.trJuchuHinmokuId = null
        x.trSagyoHinmokuId = null
        x.trJuhacchusagyoRelationId = null
        x.juchuNo = null
        x.seikyuZumiFlg = false

        this.vwCD2plmd00201 = x
        this.selectNinushiCd = ''
        this.baseSectionCol = 9
        this.newEditMode = true
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      // /* eslint no-debugger: "warn" */
      // debugger
      const initVwCD2plmd00201 = Object.assign({}, this.vwCD2plmd00201)
      if (initVwCD2plmd00201.sagyoEigyoshoId !== '') {
        var mstEigyosho = indexeddb.getRecord(this.eigyoshoList, initVwCD2plmd00201.sagyoEigyoshoId)
        if (mstEigyosho) {
          initVwCD2plmd00201.sagyoEigyoshoCd = mstEigyosho.eigyoshoCd
          initVwCD2plmd00201.sagyoEigyoshoNm = mstEigyosho.eigyoshoNm
        }
      }
      if (initVwCD2plmd00201.ninushiId !== '') {
        var mstNinushi = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00201.ninushiId)
        if (mstNinushi) {
          initVwCD2plmd00201.ninushiCd = mstNinushi.torihikisakiCd
          initVwCD2plmd00201.ninushiNm = mstNinushi.torihikisakiNm
        }
      }
      if (initVwCD2plmd00201.oroshisakiId !== '') {
        var mstOroshisaki = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00201.oroshisakiId)
        if (mstOroshisaki) {
          initVwCD2plmd00201.oroshisakiCd = mstOroshisaki.torihikisakiCd
          initVwCD2plmd00201.oroshisakiNm = mstOroshisaki.torihikisakiNm
        }
      }
      if (initVwCD2plmd00201.hatsuchiId !== '') {
        var mstHatsuchi = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00201.hatsuchiId)
        if (mstHatsuchi) {
          initVwCD2plmd00201.hatsuchiCd = mstHatsuchi.hacchakuchiCd
          initVwCD2plmd00201.hatsuchiNm = mstHatsuchi.hacchakuchiNm
        }
      }
      if (initVwCD2plmd00201.chakuchiId !== '') {
        var mstChakuchi = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00201.chakuchiId)
        if (mstChakuchi) {
          initVwCD2plmd00201.chakuchiCd = mstChakuchi.hacchakuchiCd
          initVwCD2plmd00201.chakuchiNm = mstChakuchi.hacchakuchiNm
        }
      }
      if (initVwCD2plmd00201.id === 'NEW') {
        initVwCD2plmd00201.id = -1
      }
      this.chipColorTmp = initVwCD2plmd00201.color
      if (this.saveCount > 0 && initVwCD2plmd00201.id < 0) {
        this.newEditMode = true
      }
      this.vwCD2plmd00201 = Object.assign({}, initVwCD2plmd00201)
      this.onSaveAction()
    },
    onSaveAction: function () {
      const tempKakuteiFlg = this.vwCD2plmd00201.kakuteiFlg
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.vwCD2plmd00201 = data.payload
            if (self.vwCD2plmd00201.juchuYmd) { self.vwCD2plmd00201.juchuYmd = filter.dateFormatter(self.vwCD2plmd00201.juchuYmd) }
            if (self.vwCD2plmd00201.sagyoYmd) { self.vwCD2plmd00201.sagyoYmd = filter.dateFormatter(self.vwCD2plmd00201.sagyoYmd) }
            if (self.vwCD2plmd00201.hatsuchiYmd) { self.vwCD2plmd00201.hatsuchiYmd = filter.dateFormatter(self.vwCD2plmd00201.hatsuchiYmd) }
            if (self.vwCD2plmd00201.hatsuchiHms) { self.vwCD2plmd00201.hatsuchiHms = (self.vwCD2plmd00201.hatsuchiHms).slice(0, 5) }
            if (self.vwCD2plmd00201.chakuchiYmd) { self.vwCD2plmd00201.chakuchiYmd = filter.dateFormatter(self.vwCD2plmd00201.chakuchiYmd) }
            if (self.vwCD2plmd00201.chakuchiHms) { self.vwCD2plmd00201.chakuchiHms = (self.vwCD2plmd00201.chakuchiHms).slice(0, 5) }
            if (self.vwCD2plmd00201.seikyuYoteiYmd) { self.vwCD2plmd00201.seikyuYoteiYmd = filter.dateFormatter(self.vwCD2plmd00201.seikyuYoteiYmd) }
            if (!self.vwCD2plmd00201.hatsuchiNm) { self.vwCD2plmd00201.hatsuchiNm = '' }
            if (!self.vwCD2plmd00201.chakuchiNm) { self.vwCD2plmd00201.chakuchiNm = '' }

            if (!self.vwCD2plmd00201.color) { self.vwCD2plmd00201.color = self.chipColorTmp }
            self.vwCD2plmd00201.kakuteiFlg = tempKakuteiFlg
            self.vwCD2plmd00201.newEditMode = self.newEditMode
            self.$emit('save', self.vwCD2plmd00201)
            if (self.continuousSaveMode) {
              self.vwCD2plmd00201.id = -1
              self.vwCD2plmd00201.trJuchuKihonId = -1
              self.vwCD2plmd00201.trJuchuMeisaiId = -1
              self.vwCD2plmd00201.trJuchuHinmokuId = -1
              self.vwCD2plmd00201.juchuNo = ''
              self.tempVwCD2plmd00201 = Object.assign({}, self.vwCD2plmd00201)
            } else {
              self.$emit('close', undefined)
            }
            self.saveCount++
            self.newEditMode = false
            // self.continuousSaveMode = false
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2plmd00201/JuchuCreate', this.vwCD2plmd00201)
      return f
    },
    convertToDBType: function () {
      if (this.vwCD2plmd00201.yoteiSagyoJikan) {
        this.vwCD2plmd00201.yoteiSagyoJikan = filter.timeToMinFormatter(this.vwCD2plmd00201.yoteiSagyoJikan)
      }
      if (this.vwCD2plmd00201.warimashiTaishoJikan) {
        this.vwCD2plmd00201.warimashiTaishoJikan = filter.timeToMinFormatter(this.vwCD2plmd00201.warimashiTaishoJikan)
      }
      if (this.vwCD2plmd00201.taikiJikan) {
        this.vwCD2plmd00201.taikiJikan = filter.timeToMinFormatter(this.vwCD2plmd00201.taikiJikan)
      }
    },
    registerValidate: function () {
      var msg
      if (!this.vwCD2plmd00201.juchuYmd) {
        this.$refs.juchuYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.juchuEigyoshoId) {
        this.$refs.juchuEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.ninushiId) {
        this.$refs.ninushiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.sagyoYmd) {
        this.$refs.sagyoYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.sagyoEigyoshoId) {
        this.$refs.sagyoEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      /*
      if (!this.vwCD2plmd00201.hatsuchiYmd) {
        this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.hatsuchiHms && this.isRequiredHms) {
        this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.chakuchiYmd) {
        this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00201.chakuchiHms && this.isRequiredHms) {
        this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      */
      if (this.vwCD2plmd00201.hatsuchiYmd && this.vwCD2plmd00201.chakuchiYmd) {
        msg = validators.compareDate(this.vwCD2plmd00201.hatsuchiYmd, this.vwCD2plmd00201.chakuchiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00201.hatsuchiYmd && this.vwCD2plmd00201.hatsuchiHms && this.vwCD2plmd00201.chakuchiYmd && this.vwCD2plmd00201.chakuchiHms) {
        msg = validators.compareDateTime(this.vwCD2plmd00201.hatsuchiYmd, this.vwCD2plmd00201.hatsuchiHms, this.vwCD2plmd00201.chakuchiYmd, this.vwCD2plmd00201.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00201.hatsuchiHms && this.vwCD2plmd00201.chakuchiHms && this.vwCD2plmd00201.hatsuchiYmd === this.vwCD2plmd00201.chakuchiYmd && this.vwCD2plmd00201.hatsuchiHms === this.vwCD2plmd00201.chakuchiHms) {
        this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の発時刻', '同日の着時刻']))
        this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の発時刻', '同日の着時刻']))
        return false
      }
      if (this.vwCD2plmd00201.keiyakuHojoKbn === '1') {
        this.vwCD2plmd00201.hatsuchiBiko = null
        this.vwCD2plmd00201.chakuchiBiko = null
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 請求予定年月日初期値取得
    // ----------------------------------------------------------------------------------------------------
    inputYmd: function () {
      if (this.vwCD2plmd00201.keijobiKbn !== undefined) {
        if (this.vwCD2plmd00201.keijobiKbn === '1' && this.vwCD2plmd00201.hatsuchiYmd !== null && this.vwCD2plmd00201.hatsuchiYmd !== '' && this.vwCD2plmd00201.hatsuchiYmd !== undefined) {
          this.$set(this.vwCD2plmd00201, 'seikyuYoteiYmd', this.vwCD2plmd00201.hatsuchiYmd)
        } else if (this.vwCD2plmd00201.keijobiKbn === '2' && this.vwCD2plmd00201.chakuchiYmd !== null && this.vwCD2plmd00201.chakuchiYmd !== '' && this.vwCD2plmd00201.chakuchiYmd !== undefined) {
          this.$set(this.vwCD2plmd00201, 'seikyuYoteiYmd', this.vwCD2plmd00201.chakuchiYmd)
        }
      }
    },
    dispSwitchControl: function () {
      this.hatsuchiSwitch = Boolean(!this.vwCD2plmd00201.hatsuchiId && this.vwCD2plmd00201.hatsuchiBiko)
      // this.hatsuchiHmsSwitch = Boolean(!this.vwCD2plmd00201.hatsuchiHms && this.vwCD2plmd00201.hatsuchiHmsBiko)
      this.chakuchiSwitch = Boolean(!this.vwCD2plmd00201.chakuchiId && this.vwCD2plmd00201.chakuchiBiko)
      // this.chakuchiHmsSwitch = Boolean(!this.vwCD2plmd00201.chakuchiHms && this.vwCD2plmd00201.chakuchiHmsBiko)
      this.hinmeiSwitch = Boolean(!this.vwCD2plmd00201.mstHinmeiId && this.vwCD2plmd00201.hinmeiBiko)
      this.expandKeiyuchi = Boolean(this.vwCD2plmd00201.keiyuchiId2 || this.vwCD2plmd00201.keiyuchiId2Biko || this.vwCD2plmd00201.keiyuchiId3 || this.vwCD2plmd00201.keiyuchiId3Biko || this.vwCD2plmd00201.keiyuchiId4 || this.vwCD2plmd00201.keiyuchiId4Biko || this.vwCD2plmd00201.keiyuchiId5 || this.vwCD2plmd00201.keiyuchiId5Biko)
    },
    onSwitchingHatsuchiCodeToBiko: function () {
      this.hatsuchiSwitch = !this.hatsuchiSwitch
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko: function () {
      this.chakuchiSwitch = !this.chakuchiSwitch
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },

    // ----------------------------------------------------------------------------------------------------
    // 距離計算補助
    // ----------------------------------------------------------------------------------------------------
    setYoteiSokoKyori: function (e) {
      this.$set(this.vwCD2plmd00201, 'yoteiSokoKyori', e.kyoriKm)
    },

    // ----------------------------------------------------------------------------------------------------
    // 時間計算補助
    // ----------------------------------------------------------------------------------------------------
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToTimeFormatter(min)
      }
      return result
    },

    // ----------------------------------------------------------------------------------------------------
    // 請求補助
    // ----------------------------------------------------------------------------------------------------
    inputYoteiSagyoJikan: function () {
      if (this.vwCD2plmd00201.yoteiSagyoJikan) {
        this.$set(this.vwCD2plmd00201, 'yoteiSagyoJikan', this.calcTime(this.vwCD2plmd00201.yoteiSagyoJikan))
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.vwCD2plmd00201)
      temp = {
        ...temp,
        /*
        juchuEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.juchuEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingsku: e.userKingakuKazei2
      }
      this.vwCD2plmd00201 = Object.assign({}, temp)
      temp = undefined
    },
    inputTaikiJikan: function () {
      if (this.vwCD2plmd00201.taikiJikan) {
        this.$set(this.vwCD2plmd00201, 'taikiJikan', this.calcTime(String(this.vwCD2plmd00201.taikiJikan)))
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.vwCD2plmd00201.taikiJikan
      let taikiJikanTanka = this.vwCD2plmd00201.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.vwCD2plmd00201, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    // ----------------------------------------------------------------------------------------------------
    // 割増補助
    // ----------------------------------------------------------------------------------------------------
    inputWarimashiTaishoJikan: function () {
      if (this.vwCD2plmd00201.warimashiTaishoJikan) {
        this.$set(this.vwCD2plmd00201, 'warimashiTaishoJikan', this.calcTime(this.vwCD2plmd00201.warimashiTaishoJikan))
      }
    },
    calcJikanWarimashiKingaku: function () {
      if (this.vwCD2plmd00201.warimashiTaishoJikan && this.vwCD2plmd00201.warimashiJikanTanka) {
        let warimashiTaishoJikan = this.vwCD2plmd00201.warimashiTaishoJikan
        let warimashiJikanTanka = this.vwCD2plmd00201.warimashiJikanTanka

        if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '') { warimashiTaishoJikan = 0 }
        if (warimashiJikanTanka === undefined || warimashiJikanTanka === '') { warimashiJikanTanka = 0 }

        warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)
        const jikanWarimashiKingaku = this.calcFraction((warimashiTaishoJikan / 60) * warimashiJikanTanka)
        this.$set(this.vwCD2plmd00201, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
      }
    },
    calcKyoriWarimashiKingaku: function () {
      if (this.vwCD2plmd00201.warimashiTaishoKyori && this.vwCD2plmd00201.warimashiKyoriTanka) {
        let warimashiTaishoKyori = this.vwCD2plmd00201.warimashiTaishoKyori
        let warimashiKyoriTanka = this.vwCD2plmd00201.warimashiKyoriTanka

        if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '') { warimashiTaishoKyori = 0 }
        if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '') { warimashiKyoriTanka = 0 }

        const kyoriWarimashiKingaku = this.calcFraction(warimashiTaishoKyori * warimashiKyoriTanka)
        this.$set(this.vwCD2plmd00201, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
      }
    },
    calcFraction: function (x) {
      if (!this.vwCD2plmd00201.unchinHasuKeisanKbn) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.vwCD2plmd00201.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.vwCD2plmd00201.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.vwCD2plmd00201.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    // --------------------------------------------------------------------------------
    // 経由地展開
    // --------------------------------------------------------------------------------
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },
    // ----------------------------------------------------------------------------------------------------
    // GoogleMapリンク
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiId) || ![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiBiko)) {
        const hatsuchi = {
          id: this.vwCD2plmd00201.hatsuchiId,
          biko: this.vwCD2plmd00201.hatsuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId1) || ![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiBiko1)) {
        const keiyuchi = {
          id: this.vwCD2plmd00201.keiyuchiId1,
          biko: this.vwCD2plmd00201.keiyuchiBiko1,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId2) || ![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiBiko2)) {
        const keiyuchi = {
          id: this.vwCD2plmd00201.keiyuchiId2,
          biko: this.vwCD2plmd00201.keiyuchiBiko2,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId3) || ![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiBiko3)) {
        const keiyuchi = {
          id: this.vwCD2plmd00201.keiyuchiId3,
          biko: this.vwCD2plmd00201.keiyuchiBiko3,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId4) || ![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiBiko4)) {
        const keiyuchi = {
          id: this.vwCD2plmd00201.keiyuchiId4,
          biko: this.vwCD2plmd00201.keiyuchiBiko4,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId5) || ![undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiBiko5)) {
        const keiyuchi = {
          id: this.vwCD2plmd00201.keiyuchiId5,
          biko: this.vwCD2plmd00201.keiyuchiBiko5,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiYmd) ? this.vwCD2plmd00201.hatsuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.hatsuchiHms) ? this.vwCD2plmd00201.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if (![undefined, null, ''].includes(this.vwCD2plmd00201.chakuchiId) || ![undefined, null, ''].includes(this.vwCD2plmd00201.chakuchiBiko)) {
        const chakuchi = {
          id: this.vwCD2plmd00201.chakuchiId,
          biko: this.vwCD2plmd00201.chakuchiBiko,
          ymdhms: (![undefined, null, ''].includes(this.vwCD2plmd00201.chakuchiYmd) ? this.vwCD2plmd00201.chakuchiYmd : '2999/12/31') + (![undefined, null, ''].includes(this.vwCD2plmd00201.chakuchiHms) ? this.vwCD2plmd00201.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },

    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.vwCD2plmd00201.hatsuchiId,
        hatsuchiBiko: this.vwCD2plmd00201.hatsuchiBiko,
        keiyuchiId1: this.vwCD2plmd00201.keiyuchiId1,
        keiyuchiBiko1: this.vwCD2plmd00201.keiyuchiBiko1,
        keiyuchiId2: this.vwCD2plmd00201.keiyuchiId2,
        keiyuchiBiko2: this.vwCD2plmd00201.keiyuchiBiko2,
        keiyuchiId3: this.vwCD2plmd00201.keiyuchiId3,
        keiyuchiBiko3: this.vwCD2plmd00201.keiyuchiBiko3,
        keiyuchiId4: this.vwCD2plmd00201.keiyuchiId4,
        keiyuchiBiko4: this.vwCD2plmd00201.keiyuchiBiko4,
        keiyuchiId5: this.vwCD2plmd00201.keiyuchiId5,
        keiyuchiBiko5: this.vwCD2plmd00201.keiyuchiBiko5,
        chakuchiId: this.vwCD2plmd00201.chakuchiId,
        chakuchiBiko: this.vwCD2plmd00201.chakuchiBiko
      }

      // 既存値初期化
      this.vwCD2plmd00201.hatsuchiId = null
      this.vwCD2plmd00201.hatsuchiBiko = null
      this.vwCD2plmd00201.keiyuchiId1 = null
      this.vwCD2plmd00201.keiyuchiBiko1 = null
      this.vwCD2plmd00201.keiyuchiId2 = null
      this.vwCD2plmd00201.keiyuchiBiko2 = null
      this.vwCD2plmd00201.keiyuchiId3 = null
      this.vwCD2plmd00201.keiyuchiBiko3 = null
      this.vwCD2plmd00201.keiyuchiId4 = null
      this.vwCD2plmd00201.keiyuchiBiko4 = null
      this.vwCD2plmd00201.keiyuchiId5 = null
      this.vwCD2plmd00201.keiyuchiBiko5 = null
      this.vwCD2plmd00201.chakuchiId = null
      this.vwCD2plmd00201.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId)) {
        this.vwCD2plmd00201.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.vwCD2plmd00201.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId)) {
        this.vwCD2plmd00201.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.vwCD2plmd00201.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5)) {
        this.vwCD2plmd00201.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.vwCD2plmd00201.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4)) {
        if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId1)) {
          this.vwCD2plmd00201.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.vwCD2plmd00201.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.vwCD2plmd00201.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.vwCD2plmd00201.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3)) {
        if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId1)) {
          this.vwCD2plmd00201.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.vwCD2plmd00201.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId2)) {
          this.vwCD2plmd00201.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.vwCD2plmd00201.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.vwCD2plmd00201.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.vwCD2plmd00201.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2)) {
        if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId1)) {
          this.vwCD2plmd00201.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.vwCD2plmd00201.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId2)) {
          this.vwCD2plmd00201.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.vwCD2plmd00201.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId3)) {
          this.vwCD2plmd00201.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.vwCD2plmd00201.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.vwCD2plmd00201.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.vwCD2plmd00201.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1)) {
        if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId1)) {
          this.vwCD2plmd00201.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.vwCD2plmd00201.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId2)) {
          this.vwCD2plmd00201.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.vwCD2plmd00201.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId3)) {
          this.vwCD2plmd00201.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.vwCD2plmd00201.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.vwCD2plmd00201.keiyuchiId4)) {
          this.vwCD2plmd00201.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.vwCD2plmd00201.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.vwCD2plmd00201.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.vwCD2plmd00201.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },
    // --------------------------------------------------------------------------------
    // カラーリセット
    // --------------------------------------------------------------------------------
    onUndoChipColor: function () {
      this.vwCD2plmd00201.color = this.chipColorTmp
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    getTeikeiInfo: function (teikeiCourseNo) {
      var teikeiCourse = this.teikeiCourseList.find((t) => {
        return t.teikeiCourseNo === teikeiCourseNo
      })
      return teikeiCourse
    },
    setJuchuEigyosho: function () {
      if (this.vwCD2plmd00201.juchuEigyoshoId) {
        this.vwCD2plmd00201.juchuEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.vwCD2plmd00201.juchuEigyoshoId).eigyoshoCd
      }
    },
    setHinmei: function () {
      if (this.vwCD2plmd00201.mstHinmeiId) {
        this.vwCD2plmd00201.hinmeiCd = indexeddb.getRecord(this.hinmeiList, this.vwCD2plmd00201.mstHinmeiId).hinmeiCd
      }
    },
    setHatsuchiId: function () {
      if (this.vwCD2plmd00201.hatsuchiId) {
        this.vwCD2plmd00201.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.vwCD2plmd00201.hatsuchiId).hacchakuchiCd
      }
    },
    setChakuchiId: function () {
      if (this.vwCD2plmd00201.chakuchiId) {
        this.vwCD2plmd00201.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.vwCD2plmd00201.chakuchiId).hacchakuchiCd
      }
    }
  }
}
